///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
    no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
    no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0 */
/* global AUTOBAHN_DEBUG:true */


var rand_normal = function(mean, sd) {
    // Derive a Gaussian from Uniform random variables
    // http://en.wikipedia.org/wiki/Box%E2%80%93Muller_transform
    var x1, x2, rad;

    do {
        x1 = 2 * Math.random() - 1;
        x2 = 2 * Math.random() - 1;
        rad = x1 * x1 + x2 * x2;
    } while (rad >= 1 || rad == 0);

    var c = Math.sqrt(-2 * Math.log(rad) / rad);

    return (mean || 0) + (x1 * c) * (sd || 1);
};



var assert = function(cond, text) {
    if (cond) {
        return;
    }
    if (assert.useDebugger || ('AUTOBAHN_DEBUG' in window && AUTOBAHN_DEBUG)) {
        debugger;
    }

    throw new Error(text || "Assertion failed!");
};


/**
* Merge a list of objects from left to right
*
* For each object passed to the function, add to the previous object the keys
*     that are present in the former but not the latter. If the last argument
*     is a boolean, it sets whether or not to recursively merge objects.
*
* This function mutates the first passed object. To avopid this, you can pass
*     a new empty object as the first arg:
*
*     defaults({}, obj1, obj2, ...)
*
* @example
*     defaults({ a: 1 }, { a: 2, b: 2 }, { b: 3, c: 3 })
*     // { a: 1, b: 2, c: 3 }
*
*     defaults({ a: { k1: 1 } }, { a: { k2: 2 } })
*     // { a: { k1: 1 } }
*
*     defaults({ a: { k1: 1 } }, { a: { k2: 2 } })
*     // { a: { k1: 1 } }
*
* @param {Object} base The object to merge defaults to
* @param {Object} source[, ...] The default values source
* @param {Boolean} [recursive] Whether to recurse fro object values*
*     (default: false)
* @returns {Object} The mutated `base` object
*/
var defaults = function() {
    // Return an empty object if no arguments are passed
    if (arguments.length === 0) return {};

    var base = arguments[0];
    var recursive = false;
    var len = arguments.length;

    // Check for recursive mode param
    if (typeof arguments[len - 1] === 'boolean') {
        recursive = arguments[len - 1];
        len -= 1; // Ignore the last arg
    }

    // Merging function used by Array#forEach()
    var do_merge = function(key) {
        var val = obj[key];

        // Set if unset
        if (!(key in base)) {
            base[key] = val;
            // If the value is an object and we use recursive mode, use defaults on
            // the value
        } else if (recursive && typeof val === 'object' &&
        typeof base[key] === 'object') {
            defaults(base[key], val);
        }
        // Otherwise ignore the value
    };

    // Iterate over source objects
    for (var i=1; i < len; i++) {
        var obj = arguments[i];

        // Ignore falsy values
        if (!obj) continue;

        // Require object
        if (typeof obj !== 'object') {
            throw new Error('Expected argument at index ' + i +
            ' to be an object');
        }

        // Merge keys
        Object.keys(obj).forEach(do_merge);
    }

    // Return the mutated base object
    return base;
};



/**
 * http_get_jsonp - retrieves jsonp data (cross-domain)
 *
 * @param  {string}             url = ''                        url of method to call
 * @param  {string}             funcParam = '%s'                substring URL callback function name
 * @param  {int}                [timeout = DEFAULT_TIMEOUT]     s/e, in milliseconds
 * @return {object}             Promise
 */
var scriptTarget = document.body;
var http_get_jsonp = function(url, funcParam, timeout) {
    return new Promise(function(resolve, reject) {
        // Timestamp & random factor
        var timestamp = (Date.now && Date.now()) || new Date().getTime();
        var generatedFunction = 'jsonp' + Math.round(timestamp + Math.random() * 1000001);

        // script tag
        var jsonpScript = null;

        // Delete window callback
        var cleanup = function() {
            scriptTarget.removeChild(jsonpScript);
            try {
                delete window[generatedFunction];
            } catch (e) {
                /* eslint no-undefined:0 */
                window[generatedFunction] = undefined; // IE8
            }
        };

        // Wait a while, then reject the promise
        var timeoutRejection = setTimeout(function() {
            cleanup();
            reject();
        }, timeout || 30000);

        // Attach generated function
        window[generatedFunction] = function(result) {
            cleanup();
            clearTimeout(timeoutRejection);
            resolve(result);
        };

        // Create <script> tag
        jsonpScript = document.createElement('script');
        jsonpScript.setAttribute('src', url.replace(funcParam, generatedFunction) + (url.indexOf('?') !== -1 ? '&' : '?') + 't' + timestamp + '=' + timestamp);

        // Locate a script target
        if (scriptTarget === null) {
            scriptTarget = document.head;
            if (!scriptTarget) {
                scriptTarget = document.body;
            }
        }

        // Append
        var appendJsonpScript = function() {
            scriptTarget.appendChild(jsonpScript);
            window.removeEventListener('load', appendJsonpScript);
        }
        if (scriptTarget) {
            appendJsonpScript();
        } else {
            window.addEventListener('load', appendJsonpScript);
        }
    });
}


/**
 * http_post_jsonp - sends jsonp data (cross-domain); always resolves
 *
 * @param  {string}             url = ''                        url of method to call
 * @param  {string}             data = {}                       data to be sent
 * @param  {int}                [timeout = DEFAULT_TIMEOUT]     s/e, in milliseconds
 * @return {object}             Promise
 */
var http_post_json = function(url, data, timeout) {
    return new Promise(function(resolve, reject) {
        var timestamp = (Date.now && Date.now()) || new Date().getTime();
        var generatedName = 'iframe' + Math.round(timestamp + Math.random() * 1000001);
        var rejectionTimeout = null;

        // Iframe
        var iframe = document.createElement('iframe');
        var form = document.createElement('form');
        iframe.name = generatedName;
        iframe.style.display = 'none';

        // Cleanup
        var cleanup = function() {
            iframe.parentNode.removeChild(iframe);
            form.parentNode.removeChild(form);
            clearTimeout(rejectionTimeout);
        }

        // Form
        form.style.display = 'none';
        form.method = 'post';
        form.action = url;
        form.target = generatedName;

        for (var i in data) {
            if (data.hasOwnProperty(i)) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = i;
                input.value = data[i];
                form.appendChild(input);
            }
        }

        // Append
        var appendJsonpScript = function() {
            window.removeEventListener('load', appendJsonpScript);
            document.body.appendChild(iframe);
            document.body.appendChild(form);

            iframe.onload = function() {
                cleanup();
                resolve();
            }

            form.submit();
        }

        // Reject after specific interval
        rejectionTimeout = setTimeout(function() {
            window.removeEventListener('load', appendJsonpScript);
            cleanup();
            reject();
        }, timeout || 30000);

        // Do the job or wait
        if (document.body) {
            appendJsonpScript();
        } else {
            window.addEventListener('load', appendJsonpScript);
        }
    });
}

/**
 * Exports
 */
exports.http_get_jsonp = http_get_jsonp;
exports.http_post_json = http_post_json;
exports.rand_normal = rand_normal;
exports.assert = assert;
exports.defaults = defaults;



// WEBPACK FOOTER //
// ./src/lightweight-autobahn/src/util.js